import { darken, lighten } from "@mui/material";
import { COLOR_VARIABLES } from "./colors";

import dashboard_bg_yellow from 'resources/images/dashboard_bg_yellow.png';
import dashboard_bg_round_map from 'resources/images/dashboard_bg_round_map.png';
import loginImage from '../resources/images/header_geomachine.jpeg';
import gm_logo from 'resources/images/gm-full.png';

import gcm_login_bg from 'resources/images/gcm/geocadia_bg.jpg'
import gcm_login_bg2 from 'resources/images/gcm/geocadia_bg_2.jpg'
import gcm_org_logo from 'resources/images/gcm/Geocadia_logotyp_neg.png';
import gcm_dashboard_gb_orange from 'resources/images/gcm/dashboard_bg_orange.png';


const GM_THEME = {
    primary: COLOR_VARIABLES.colors_yellow,
    primaryDark: darken(COLOR_VARIABLES.colors_yellow, 0.2),
    primaryLight: lighten(COLOR_VARIABLES.colors_yellow, 0.2),
    primaryText: COLOR_VARIABLES.colors_black,

    secondary: COLOR_VARIABLES.colors_darkgray, //COLOR_VARIABLES.colors_black,
    secondaryDark: darken(COLOR_VARIABLES.colors_darkgray, 0.2), //darken(COLOR_VARIABLES.colors_black, 0.2),
    secondaryLight: lighten(COLOR_VARIABLES.colors_darkgray, 0.2), //lighten(COLOR_VARIABLES.colors_black, 0.2),
    secondaryText: COLOR_VARIABLES.colors_white,

    disabledBgColor: COLOR_VARIABLES.colors_ultraligh,
    disabled: COLOR_VARIABLES.colors_midgray,
    dashboardBgColor: COLOR_VARIABLES.colors_white,

    successColor: COLOR_VARIABLES.colors_green,
    warningColor: COLOR_VARIABLES.colors_red,
    errorColor: COLOR_VARIABLES.colors_red,

    background: COLOR_VARIABLES.colors_white,
    dashboardBgImage: dashboard_bg_yellow,
    dashboardImage: dashboard_bg_round_map,
    organizationLogo: gm_logo,
    LoginBackgroundImage: loginImage,

    stateOpen: COLOR_VARIABLES.colors_state_open,
    stateAssigned: COLOR_VARIABLES.colors_state_assigned,
    stateResourced: COLOR_VARIABLES.colors_state_resourced,
    statePaused: COLOR_VARIABLES.colors_state_paused,
    stateOngoing: COLOR_VARIABLES.colors_state_ongoing,
    stateDone: COLOR_VARIABLES.colors_state_done,
    stateCancelled: COLOR_VARIABLES.colors_state_cancelled,
    stateFailed: COLOR_VARIABLES.colors_state_failed,

    colorWhite: COLOR_VARIABLES.colors_white,
    colorLightGray: COLOR_VARIABLES.colors_lightgray
};

const GCM_THEME = {
    primary: COLOR_VARIABLES.colors_orange,
    primaryDark: darken(COLOR_VARIABLES.colors_orange, 0.2),
    primaryLight: lighten(COLOR_VARIABLES.colors_orange, 0.2),
    primaryText: COLOR_VARIABLES.colors_black,

    secondary: COLOR_VARIABLES.colors_darkgray, //COLOR_VARIABLES.colors_black,
    secondaryDark: darken(COLOR_VARIABLES.colors_darkgray, 0.2), //darken(COLOR_VARIABLES.colors_black, 0.2),
    secondaryLight: lighten(COLOR_VARIABLES.colors_darkgray, 0.2), //lighten(COLOR_VARIABLES.colors_black, 0.2),
    secondaryText: COLOR_VARIABLES.colors_white,

    disabledBgColor: COLOR_VARIABLES.colors_ultraligh,
    disabled: COLOR_VARIABLES.colors_midgray,
    dashboardBgColor: COLOR_VARIABLES.colors_white,

    successColor: COLOR_VARIABLES.colors_green,
    warningColor: COLOR_VARIABLES.colors_red,
    errorColor: COLOR_VARIABLES.colors_red,

    background: COLOR_VARIABLES.colors_white,
    dashboardBgImage: gcm_dashboard_gb_orange,
    dashboardImage: dashboard_bg_round_map,
    organizationLogo: gcm_org_logo,
    LoginBackgroundImage: gcm_login_bg2,

    stateOpen: COLOR_VARIABLES.colors_state_open,
    stateAssigned: COLOR_VARIABLES.colors_state_assigned,
    stateResourced: COLOR_VARIABLES.colors_state_resourced,
    statePaused: COLOR_VARIABLES.colors_state_paused,
    stateOngoing: COLOR_VARIABLES.colors_state_ongoing,
    stateDone: COLOR_VARIABLES.colors_state_done,
    stateCancelled: COLOR_VARIABLES.colors_state_cancelled,
    stateFailed: COLOR_VARIABLES.colors_state_failed,

    colorWhite: COLOR_VARIABLES.colors_white,
    colorLightGray: COLOR_VARIABLES.colors_lightgray,
    colorLightBlue: COLOR_VARIABLES.colors_light_blue
};

export const DEFAULTTHEME = process.env.REACT_APP_THEME === 'GCM' ? GCM_THEME : GM_THEME;